export function createBoundsFromLatLngArray(latLngArray: (google.maps.LatLng | google.maps.LatLngLiteral)[]) {
	const bounds = new google.maps.LatLngBounds();
	for (const latLng of latLngArray) {
		bounds.extend(latLng);
	}
	return bounds;
}
